import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo accedo al Pack después de comprar?',
    a: 'Te llega un enlace de descarga inmediata a tu correo.'
  }, {
    q: '¿Es un producto físico o digital?',
    a: 'Es 100% digital, para usar en cualquier dispositivo.'
  }, {
    q: '¿Necesito imprimir el material?',
    a: 'No es necesario. Podés consultarlo en tu celular, tablet o computadora.'
  }, {
    q: '¿El pago es por única vez?',
    a: 'Sí, es un pago único, sin suscripciones.'
  }, {
    q: '¿Es segura la compra?',
    a: 'Absolutamente, la transacción es 100% segura.'
  }, {
    q: '¿Sirve si soy profesor o entrenador?',
    a: 'Sí, es ideal para cualquiera que quiera trabajar con criterio profesional real.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-10 bg-card/30 border-y border-card-border relative overflow-hidden" data-id="element-77">
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-78">
        <FadeIn className="text-center mb-10" data-id="element-79">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-80">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-gray-400" data-id="element-81">
            Despejá todas tus dudas antes de empezar.
          </p>
        </FadeIn>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-83">
              <div className="bg-card border border-card-border rounded-2xl overflow-hidden transition-colors hover:border-primary/30" data-id="element-84">
                <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-85">
                  <span className="text-lg font-bold text-white pr-8" data-id="element-86">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="shrink-0" data-id="element-87">
                    <ChevronDownIcon className="w-6 h-6 text-primary" data-id="element-88" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-89">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-90">
                      <div className="px-6 pb-6 text-gray-400 leading-relaxed border-t border-card-border/50 pt-4" data-id="element-91">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}